import { gql } from '@apollo/client';
export const transactionDetailsFragment = gql `
  fragment transactionDetailsFields on RecentTransactionDetailsPayload {
    type
    assetCode
    assetLabel
    assetIconUrl

    method

    fee
    feeAssetCode

    amount
    estimatedAmount
    quoteAmount
    quoteAssetCode
    quoteAssetLabel

    krakenCost
    krakenFee
    totalKrakenCost
  }
`;
export const transactionDetailsExtendedFragment = gql `
  fragment transactionDetailsExtendedFields on TransactionDetailPayload {
    type
    assetCode
    assetLabel

    fee
    feeAssetCode

    amount

    quoteAmount
    quoteAssetCode
    quoteAssetLabel

    krakenCost
    krakenFee
    totalKrakenCost

    status
    subStatus
    network
    internalOperationId
    destination
    sourceAddress
    date
    rate
    blockchainTransactionId
    recipientAccountNumber

    bitnetId

    reasonForFailure
  }
`;
//TODO: should add
// reason
// initiatorEmail
//# sourceMappingURL=transaction.js.map